import React from "react";

const NotFound = () => {
  return (
    <>
      <h1 className="text-primary text-center">Not Found Page</h1>
    </>
  );
};

export default NotFound;
